'use strict';
import * as $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dBased$002dOn$002dResult$0024$0024anon$00242 from "./app.pages.-Document-Templates-Create-Page$-Based-On-Result$$anon$2.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
function $s_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone__Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult() {
  $m_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$();
  return $t_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone;
}
export { $s_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone__Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult as $s_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone__Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult };
/** @constructor */
function $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$() {
  $n_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$ = this;
  $t_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone = new $j_app$002epages$002e$002dDocument$002dTemplates$002dCreate$002dPage$0024$002dBased$002dOn$002dResult$0024$0024anon$00242.$c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$$anon$2("Standalone", 0);
}
export { $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$ as $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$ };
$p = $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$;
/** @constructor */
function $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$() {
}
export { $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$ as $h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$ };
$h_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$.prototype = $p;
$p.dl = (function(x) {
  return x.co();
});
var $d_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$, "app.pages.DocumentTemplatesCreatePage$BasedOnResult$", ({
  Hu: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$ as $d_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$ };
var $n_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$;
function $m_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$() {
  if ((!$n_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$)) {
    $n_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$ = new $c_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$();
  }
  return $n_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$;
}
export { $m_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$ as $m_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$ };
var $t_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone = null;
function $u_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone(x) {
  $t_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone = x;
}
export { $t_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone as $t_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone, $u_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone as $u_Lapp_pages_DocumentTemplatesCreatePage$BasedOnResult$__Standalone };
//# sourceMappingURL=app.pages.-Document-Templates-Create-Page$-Based-On-Result$.js.map
